// extracted by mini-css-extract-plugin
export var banner = "_pw-0";
export var settingRow = "_pw-2";
export var titleIcon = "_pw-1";